import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormGroup, FormControl, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/platform-browser';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/inputtextarea';
import * as i6 from 'primeng/dialog';
import * as i7 from 'primeng/accordion';
import * as i8 from 'primeng/api';
import * as i9 from 'primeng/radiobutton';
import { PrimengLibraryModule } from 'primeng-library';
import { TreeModule } from 'primeng/tree';

class LibRolesResponsibilityService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getSuggestionList() {
        return this.http.get(`/vd/formBuilder/requisition/rolesAndResponsibilities/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibRolesResponsibilityService.ɵfac = function LibRolesResponsibilityService_Factory(t) { return new (t || LibRolesResponsibilityService)(i0.ɵɵinject(i1.HttpClient)); };
LibRolesResponsibilityService.ɵprov = i0.ɵɵdefineInjectable({ token: LibRolesResponsibilityService, factory: LibRolesResponsibilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibRolesResponsibilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["accordion"];
function LibRolesResponsibilityComponent_em_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 24);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function LibRolesResponsibilityComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵlistener("click", function LibRolesResponsibilityComponent_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.showDialog(); });
    i0.ɵɵtext(1, "Roles & Responsibility Suggestion");
    i0.ɵɵelementEnd();
} }
function LibRolesResponsibilityComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1, " Required");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function LibRolesResponsibilityComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Minimum length is ", ctx_r3.inputParams == null ? null : ctx_r3.inputParams.minLength, "");
} }
function LibRolesResponsibilityComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Maximum length is ", ctx_r4.inputParams.maxLength, "");
} }
function LibRolesResponsibilityComponent_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵtext(1, "Recommended");
    i0.ɵɵelementEnd();
} }
function LibRolesResponsibilityComponent_div_29_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "p-radioButton", 33);
    i0.ɵɵlistener("click", function LibRolesResponsibilityComponent_div_29_ng_template_6_Template_p_radioButton_click_1_listener() { i0.ɵɵrestoreView(_r15); const i_r10 = i0.ɵɵnextContext().index; const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.chooseSuggestion(i_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 34);
    i0.ɵɵelement(3, "span", 35);
    i0.ɵɵelement(4, "span", 36);
} if (rf & 2) {
    const i_r10 = i0.ɵɵnextContext().index;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].radio)("value", ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].radio);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", (ctx_r12.childGroup.controls["selectedCategory"].value[i_r10] == null ? null : ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].jobDescription) ? ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].jobDescription : "--", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", (ctx_r12.childGroup.controls["selectedCategory"].value[i_r10] == null ? null : ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].rolesAndResponsibility) ? ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].rolesAndResponsibility : "--", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", (ctx_r12.childGroup.controls["selectedCategory"].value[i_r10] == null ? null : ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].skillsRequired) ? ctx_r12.childGroup.controls["selectedCategory"].value[i_r10].skillsRequired : "--", i0.ɵɵsanitizeHtml);
} }
const _c1 = function (a0) { return { "odd": a0 }; };
function LibRolesResponsibilityComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "label", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "p-accordion", 30, 31);
    i0.ɵɵelementStart(5, "p-accordionTab");
    i0.ɵɵtemplate(6, LibRolesResponsibilityComponent_div_29_ng_template_6_Template, 5, 5, "ng-template", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const suggestion_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, 0 !== i_r10 % 2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", suggestion_r9.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("multiple", true);
} }
const _c2 = function (a0) { return { "margin-left": a0 }; };
const _c3 = function () { return { width: "70vw" }; };
class LibRolesResponsibilityComponent {
    constructor(fb, sanitizer, rolesResponsibilityService, cdr) {
        this.fb = fb;
        this.sanitizer = sanitizer;
        this.rolesResponsibilityService = rolesResponsibilityService;
        this.cdr = cdr;
        this.observableSubscription$ = new Subject();
        this.visible = false;
        this.suggestionsList = [];
        this.selectedRadioIndex = 0;
    }
    showDialog() {
        this.visible = true;
    }
    ngOnInit() {
        var _a, _b, _c, _d;
        this.getSuggestionList();
        const roleAndRespValidators = this.inputParams.mandatory ? [Validators.required] : [];
        if (((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.mandatory) && ((_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.minLength)) {
            roleAndRespValidators.push(Validators.minLength(this.inputParams.minLength));
        }
        if (((_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.mandatory) && ((_d = this.inputParams) === null || _d === void 0 ? void 0 : _d.maxLength)) {
            roleAndRespValidators.push(Validators.maxLength(this.inputParams.maxLength));
        }
        this.group.addControl(this.inputParams.name, new FormGroup({
            rolesAndResponsibility: new FormControl(this.inputParams.value ? this.inputParams.value.code ? this.inputParams.value.code : this.inputParams.value.rolesAndResponsibility : null, roleAndRespValidators),
            jobDescription: new FormControl(),
            skillsRequired: new FormControl(),
            selectedCategory: new FormArray([]),
            id: new FormControl()
        }));
        this.childGroup = (this.group.controls[this.inputParams.name]);
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    stripHtmlTags(str) {
        if (!str) {
            return '';
        }
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }
    getFormArray() {
        return this.childGroup.get('selectedCategory');
    }
    getSuggestionList() {
        this.rolesResponsibilityService.getSuggestionList().pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.suggestionsList = response.data || [];
            this.populateData();
        });
    }
    populateData() {
        var arrayControl = this.childGroup.get("selectedCategory");
        this.suggestionsList.forEach((item) => {
            arrayControl.push(this.addControls(item));
        });
        this.cdr.detectChanges();
    }
    addControls(item) {
        return this.fb.group({
            rolesAndResponsibility: item.rolesAndResponsibility,
            jobDescription: item.jobDescription,
            skillsRequired: this.sanitizer.bypassSecurityTrustHtml(item.skillsRequired),
            radio: item.id,
            selectedradiovalue: item.selectedid,
            id: item.id,
        });
    }
    addSuggestion() {
        var arrayControl = this.childGroup.get("selectedCategory");
        this.formattedRolesAndResponsibility = this.stripHtmlTags(arrayControl.at(this.selectedRadioIndex).get("rolesAndResponsibility").value);
        this.childGroup.controls['rolesAndResponsibility'].setValue(this.formattedRolesAndResponsibility);
        this.childGroup.controls['jobDescription'].setValue(arrayControl.at(this.selectedRadioIndex).get("jobDescription").value);
        this.childGroup.controls['skillsRequired'].setValue(arrayControl.at(this.selectedRadioIndex).get("skillsRequired").value);
        this.childGroup.controls['id'].setValue(arrayControl.at(this.selectedRadioIndex).get("id").value);
    }
    chooseSuggestion(index) {
        this.selectedRadioIndex = index;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibRolesResponsibilityComponent.ɵfac = function LibRolesResponsibilityComponent_Factory(t) { return new (t || LibRolesResponsibilityComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.DomSanitizer), i0.ɵɵdirectiveInject(LibRolesResponsibilityService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LibRolesResponsibilityComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibRolesResponsibilityComponent, selectors: [["lib-roles-responsibility"]], viewQuery: function LibRolesResponsibilityComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
    } }, inputs: { inputParams: "inputParams", group: "group" }, decls: 37, vars: 20, consts: [[1, "container-fluid", "roles-responsibilities", "p-0", "mt-2", "mb-2", "pb-3", 3, "formGroup"], [1, "row"], [1, "p-col-12"], [1, ""], ["class", "error", 4, "ngIf"], ["href", "javascript:void(0);", "class", "float-right", 3, "click", 4, "ngIf"], ["rows", "10", "formControlName", "rolesAndResponsibility", "placeholder", "Enter", "pInputTextarea", "", "autoResize", "autoResize", 1, "d-block"], [4, "ngIf"], [1, "col-12"], ["header", "Recommended Job Details", 3, "visible", "modal", "draggable", "resizable", "visibleChange"], [1, "row", "job_desc_header", "p-2", "mt-1"], [1, "col-11", "p-0", "row"], [1, "arrowsty"], [1, "radiosty"], [1, "col-3", "pl-3"], [1, "pl-2"], [1, "col-4", "pl-3"], [1, "col-12", "border", "p-0", "pt-2"], ["class", "recommend pl-2 pr-2 m-2", 4, "ngIf"], ["formArrayName", "selectedCategory", "class", "field-checkbox mb-2", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "col-6"], [1, "col-12", "text-right"], ["type", "button", 1, "btn", "vdCancelBtn", "mr-3", "mt-3", 3, "click"], ["type", "submit", 1, "btn", "vdCreateBtn", "mt-3", 3, "click"], [1, "error"], ["href", "javascript:void(0);", 1, "float-right", 3, "click"], [1, "recommend", "pl-2", "pr-2", "m-2"], ["formArrayName", "selectedCategory", 1, "field-checkbox", "mb-2", 3, "ngClass"], [1, "ml-2", "row", 3, "for"], [1, "col-11", "p-0", 3, "formGroupName"], [3, "multiple"], ["accordion", ""], ["pTemplate", "header"], ["formControlName", "selectedradiovalue", 3, "inputId", "value", "click"], [1, "p-accordion-header-text", "headercol", "col-3", "pl-0", 3, "innerHtml"], [1, "p-accordion-header-text", "headercol", "col-4", 3, "innerHtml"], [1, "p-accordion-header-text", "headercol", "col-3", 3, "innerHTML"]], template: function LibRolesResponsibilityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, "Job Roles & Responsibility");
        i0.ɵɵtemplate(5, LibRolesResponsibilityComponent_em_5_Template, 2, 0, "em", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, LibRolesResponsibilityComponent_a_6_Template, 2, 0, "a", 5);
        i0.ɵɵelement(7, "textarea", 6);
        i0.ɵɵtemplate(8, LibRolesResponsibilityComponent_span_8_Template, 3, 0, "span", 4);
        i0.ɵɵtemplate(9, LibRolesResponsibilityComponent_ng_container_9_Template, 4, 1, "ng-container", 7);
        i0.ɵɵtemplate(10, LibRolesResponsibilityComponent_ng_container_10_Template, 4, 1, "ng-container", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "p-dialog", 9);
        i0.ɵɵlistener("visibleChange", function LibRolesResponsibilityComponent_Template_p_dialog_visibleChange_12_listener($event) { return ctx.visible = $event; });
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelement(15, "div", 12);
        i0.ɵɵelement(16, "div", 13);
        i0.ɵɵelementStart(17, "div", 14);
        i0.ɵɵelementStart(18, "h6", 15);
        i0.ɵɵtext(19, "Job Description");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 16);
        i0.ɵɵelementStart(21, "h6");
        i0.ɵɵtext(22, "Job Roles & Responsibility");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵelementStart(24, "h6");
        i0.ɵɵtext(25, "Skills");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 1);
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵtemplate(28, LibRolesResponsibilityComponent_span_28_Template, 2, 0, "span", 18);
        i0.ɵɵtemplate(29, LibRolesResponsibilityComponent_div_29_Template, 7, 6, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 1);
        i0.ɵɵelement(31, "div", 20);
        i0.ɵɵelementStart(32, "div", 21);
        i0.ɵɵelementStart(33, "button", 22);
        i0.ɵɵlistener("click", function LibRolesResponsibilityComponent_Template_button_click_33_listener() { return ctx.visible = !ctx.visible; });
        i0.ɵɵtext(34, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "button", 23);
        i0.ɵɵlistener("click", function LibRolesResponsibilityComponent_Template_button_click_35_listener() { ctx.addSuggestion(); return ctx.visible = !ctx.visible; });
        i0.ɵɵtext(36, "Add Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_6_0 = null;
        let tmp_6_1 = null;
        let tmp_7_0 = null;
        let tmp_7_1 = null;
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(17, _c2, (ctx.inputParams == null ? null : ctx.inputParams.coordinateX) + "px"));
        i0.ɵɵproperty("formGroup", ctx.childGroup);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.suggestionsList.length !== 0);
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("maxlength", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) > 0 ? ctx.inputParams == null ? null : ctx.inputParams.maxLength : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("rolesAndResponsibility").value === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.minLength) !== null && (ctx.inputParams == null ? null : ctx.inputParams.minLength) !== "" && (ctx.group == null ? null : (tmp_6_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : (tmp_6_1 = tmp_6_0.get("rolesAndResponsibility")) == null ? null : tmp_6_1.value == null ? null : tmp_6_1.value.length) < (ctx.inputParams == null ? null : ctx.inputParams.minLength) && (ctx.group == null ? null : (tmp_6_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_6_0.touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) && (ctx.inputParams == null ? null : ctx.inputParams.maxLength) !== "" && (ctx.group == null ? null : (tmp_7_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : (tmp_7_1 = tmp_7_0.get("rolesAndResponsibility")) == null ? null : tmp_7_1.value == null ? null : tmp_7_1.value.length) == (ctx.inputParams == null ? null : ctx.inputParams.maxLength));
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(19, _c3));
        i0.ɵɵproperty("visible", ctx.visible)("modal", true)("draggable", false)("resizable", false);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("ngIf", ctx.suggestionsList.length !== 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.getFormArray().controls);
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i4.NgIf, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i5.InputTextarea, i1$1.MaxLengthValidator, i6.Dialog, i4.NgForOf, i1$1.FormArrayName, i4.NgClass, i1$1.FormGroupName, i7.Accordion, i7.AccordionTab, i8.PrimeTemplate, i9.RadioButton], styles: [".roles-responsibilities[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{width:100%}.roles-responsibilities[_ngcontent-%COMP%]   .job_header[_ngcontent-%COMP%]{background:#efefef;align-items:center}.roles-responsibilities[_ngcontent-%COMP%]   .job_desc_header[_ngcontent-%COMP%]{background:#edf4fb}.roles-responsibilities[_ngcontent-%COMP%]   .job_desc_header[_ngcontent-%COMP%]   .radiosty[_ngcontent-%COMP%]{width:20px}.roles-responsibilities[_ngcontent-%COMP%]   .odd[_ngcontent-%COMP%]{background:#f8f9fa}.roles-responsibilities[_ngcontent-%COMP%]   .border[_ngcontent-%COMP%]{border:solid #eff5fa}.roles-responsibilities[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{display:inline-block;font-weight:600;padding-left:20px}.roles-responsibilities[_ngcontent-%COMP%]   .radiosty[_ngcontent-%COMP%]{display:flex;align-items:center;padding-left:10px;padding-right:15px}.roles-responsibilities[_ngcontent-%COMP%]   .arrowsty[_ngcontent-%COMP%]{max-width:6%;width:6%}.roles-responsibilities[_ngcontent-%COMP%]   .job_details_section[_ngcontent-%COMP%]{background:#edf4fb}.roles-responsibilities[_ngcontent-%COMP%]   .recommend[_ngcontent-%COMP%]{background:#ffd500;border-radius:10px;font-weight:600}.roles-responsibilities[_ngcontent-%COMP%]   .job_content[_ngcontent-%COMP%]{display:inline-block;width:33%}.roles-responsibilities[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibRolesResponsibilityComponent, [{
        type: Component,
        args: [{
                selector: 'lib-roles-responsibility',
                templateUrl: 'lib-roles-responsibility.component.html',
                styleUrls: ['lib-roles-responsibility.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.DomSanitizer }, { type: LibRolesResponsibilityService }, { type: i0.ChangeDetectorRef }]; }, { accordion: [{
            type: ViewChild,
            args: ['accordion']
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class LibRolesResponsibilityModule {
}
LibRolesResponsibilityModule.ɵfac = function LibRolesResponsibilityModule_Factory(t) { return new (t || LibRolesResponsibilityModule)(); };
LibRolesResponsibilityModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibRolesResponsibilityModule });
LibRolesResponsibilityModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            TreeModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibRolesResponsibilityModule, { declarations: [LibRolesResponsibilityComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        TreeModule], exports: [LibRolesResponsibilityComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibRolesResponsibilityModule, [{
        type: NgModule,
        args: [{
                declarations: [LibRolesResponsibilityComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TreeModule
                ],
                exports: [LibRolesResponsibilityComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-roles-responsibility
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibRolesResponsibilityComponent, LibRolesResponsibilityModule, LibRolesResponsibilityService };
//# sourceMappingURL=lib-roles-responsibility.js.map
